import { createContext, useContext, useEffect, useState } from "react";
import { EN } from "./en";

const LanguageContext = createContext(null);
const STORAGE_KEY = "gospot_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "fr";
    } catch {
      return "fr";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // La chaîne française sert de clé : repli au français si la traduction manque
  const t = (fr) => {
    if (lang !== "en" || fr == null || typeof fr !== "string") return fr;
    return EN[fr] ?? fr;
  };

  // Date longue : « vendredi 4 septembre 2026 » / « Friday, September 4, 2026 »
  const fmtDate = (iso, opts) => {
    if (!iso) return "";
    const d = new Date(`${iso}T12:00:00`);
    return new Intl.DateTimeFormat(lang === "en" ? "en-CA" : "fr-CA", opts || { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(d);
  };

  return <LanguageContext.Provider value={{ lang, setLang, t, fmtDate }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
